export default "__VITE_ASSET__BhH9Qift__"